import { Link } from 'gatsby';
import React from 'react';
import { nl2br } from '../../helpers/nl2br';
import BackgroundImage from '../../images/background-cta.jpg';

interface CtaSectionProps {
  headline: string;
}

const CtaSection = ({ headline }: CtaSectionProps) => (
  <section
    className="py-24 mt-20 text-center text-white bg-center bg-cover lg:py-32 bg-primary"
    style={{ backgroundImage: `url(${BackgroundImage})` }}
  >
    <div className="container">
      <h2
        className="max-w-3xl mx-auto mb-12 text-2xl font-bold tracking-tight md:text-3xl lg:text-4xl"
        dangerouslySetInnerHTML={{ __html: nl2br(headline) }}
      />

      <Link
        className="px-8 py-4 font-semibold transition bg-white rounded shadow text-primary hover:bg-opacity-90 focus:bg-opacity-90 u-ring focus-visible:outline-none focus-visible:ring focus-visible:ring-white focus-visible:ring-opacity-50"
        to="/get-started"
      >
        Start your Free Trial
      </Link>
    </div>
  </section>
);

export default CtaSection;
